import LiveLeaderboardNavigation from './live-leaderboard-navigation'

export default LiveLeaderboardNavigation
